const BusinessPaymentComponent = () => import('@/views/finance/BusinessPayment/BusinessPaymentView')

export default [
    {
        path:'/BusinessPaymentIndex',
        name:'BusinessPaymentComponent',
        component:BusinessPaymentComponent
    }
]